// 在整个完整页面中显示的路由定义在这里，如404页面、500页面、登录页等

// 登录页面
// const login = {
//   path: '/login',
//   name: 'login',
//   component: (resolve) => require(['../components/login.vue'], resolve)
// }

// 定义的路由需要添加到这个数组中
const customPageRouters = [
  // login
]

export default customPageRouters



// WEBPACK FOOTER //
// ./src/custom/router/custom-page-routers.js